import React from 'react';

import {
	MATERIAL_REQUISITION_PURPOSE,
	MATERIAL_REQUISITION_TYPE
} from '@features/material-requisition/utils';

import { capitalizeFirstLetter } from '@utils/Util';

const MaterialRequestTypeModal = ({
	selectedMaterialType,
	handleMaterialTypeChange,
	onCloseModal,
	toggleMaterialRequestTypeModal,
	materialRequisitionPurpose
}) => {
	return (
		<>
			<div className="common-popup-body scroll-y-label">
				<div className="choose-puprpose-box">
					<p className="regular-14 gray_dark_01 mb-2">Choose your purpose of requisition:</p>
					<div className="row">
						{materialRequisitionPurpose?.map((item) => (
							<div className="col-md-12" key={item.constant}>
								<div className="custom-radio-box custom-radio mb-12">
									<div className="form-group d-flex align-items-center">
										<input
											type="radio"
											id={item.constant}
											name="requisitionPurpose"
											onChange={handleMaterialTypeChange}
											value={item.constant}
											checked={
												selectedMaterialType.requisitionPurpose === item.constant
											}
										/>
										<label
											htmlFor={item.constant}
											className="ml-2 mb-0 gray_dark_01 regular-14"
										>
											{capitalizeFirstLetter(item.name)}
										</label>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
				<div className="choose-purpose-box">
					<p className="regular-14 gray_dark_01 mb-2">Choose type of material:</p>
					<div className="row">
						{(selectedMaterialType.requisitionPurpose === MATERIAL_REQUISITION_PURPOSE[1].constant
							? MATERIAL_REQUISITION_TYPE.slice(0, 2)
							: MATERIAL_REQUISITION_TYPE
						).map((item) => (
							<div className="col-md-12" key={item.constant}>
								<div className="custom-radio-box custom-radio mb-12">
									<div className="form-group d-flex align-items-center">
										<input
											type="radio"
											id={item.constant}
											name="materialType"
											onChange={handleMaterialTypeChange}
											value={item.constant}
											checked={selectedMaterialType.materialType === item.constant}
										/>
										<label
											htmlFor={item.constant}
											className="ml-2 mb-0 gray_dark_01 regular-14"
										>
											{item.name}
										</label>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="modal-footer">
				<div className="footer-buttons text-right">
					<button className="button outline size32 ml-2" onClick={onCloseModal}>
						Cancel
					</button>
					<button className="button size32 ml-2" onClick={toggleMaterialRequestTypeModal}>
						Next
					</button>
				</div>
			</div>
		</>
	);
};

export default MaterialRequestTypeModal;
